import { render, staticRenderFns } from "./CommunityComment.vue?vue&type=template&id=20ecfda4&scoped=true&"
import script from "./CommunityComment.vue?vue&type=script&lang=js&"
export * from "./CommunityComment.vue?vue&type=script&lang=js&"
import style0 from "./CommunityComment.vue?vue&type=style&index=0&id=20ecfda4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ecfda4",
  null
  
)

export default component.exports